import { create } from 'zustand';

interface SearchModalStore {
    isOpen: boolean;
    initialQuery: string;
    openSearch: (query?: string) => void;
    closeSearch: () => void;
    setIsOpen: (isOpen: boolean) => void;
    setInitialQuery: (query: string) => void;
}

export const useSearchModalStore = create<SearchModalStore>((set) => ({
    isOpen: false,
    initialQuery: '',
    openSearch: (query = '') => set({ isOpen: true, initialQuery: query }),
    closeSearch: () => set({ isOpen: false, initialQuery: '' }),
    setIsOpen: (isOpen: boolean) => set({ isOpen }),
    setInitialQuery: (initialQuery: string) => set({ initialQuery }),
}));
